import { gql } from "@outschool/ui-apollo";

export const LearnerQuizWriterTopicSuggestions = gql`
  query LearnerQuizWriterTopicSuggestions {
    quizWriterTopicSuggestions {
      uid
      name
      showAsUnlocked
    }
  }
`;

export const LearnerQuizWriterTopicSearch = gql`
  query LearnerQuizWriterTopicSearch($search: String) {
    quizWriterTopicSearch(search: $search) {
      uid
      name
      showAsUnlocked
    }
  }
`;

export const LearnerQuizDeleteLearnerTopic = gql`
  mutation LearnerQuizDeleteLearnerTopic($topicUid: ID!) {
    deleteLearnerTopic(topicUid: $topicUid)
  }
`;

export const LearnerQuizStartQuizAttempt = gql`
  mutation LearnerQuizStartQuizAttempt($quizUid: ID!) {
    startQuizAttempt(quizUid: $quizUid) {
      uid
      quizUid
      learnerUid
      attempt {
        selectedAnswers {
          questionIndex
          optionIndex
        }
        answeredCorrectByIndex {
          questionIndex
          correct
        }
        completed
      }
      createdAt
      updatedAt
    }
  }
`;

export const LearnerQuizUpdateQuizAttempt = gql`
  mutation LearnerQuizUpdateQuizAttempt(
    $attemptUid: ID!
    $attempt: QuizAttemptPatchInput!
  ) {
    updateQuizAttempt(attemptUid: $attemptUid, attempt: $attempt) {
      uid
      quizUid
      learnerUid
      attempt {
        selectedAnswers {
          questionIndex
          optionIndex
        }
        answeredCorrectByIndex {
          questionIndex
          correct
        }
        completed
      }
      createdAt
      updatedAt
    }
  }
`;

export const LearnerQuizCompleteQuizAttempt = gql`
  mutation LearnerQuizCompleteQuizAttempt($attemptUid: ID!) {
    completeQuizAttempt(attemptUid: $attemptUid) {
      uid
      quizUid
      learnerUid
      attempt {
        selectedAnswers {
          questionIndex
          optionIndex
        }
        answeredCorrectByIndex {
          questionIndex
          correct
        }
        completed
      }
      createdAt
      updatedAt
    }
  }
`;
